module.exports = __webpack_public_path__ + "img/weixinzixun.18f57297.jpg";